module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reload":"Reload","updateAvailable":"A new version of Baianat is available click on the link to update  "},"ar":{"reload":"تحديث","updateAvailable":"نسخة جديدة من بيانات اصبحت متوفرة, اضغط على الرابط لتفعيل احدث نسخة"}}')
  delete Component.options._Ctor
}
